import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { DeployViewResponse } from '@core/models/deploy-plan-config.model';

import { StatusPillComponent } from '@shared/components/status-pill/status-pill.component';

import { DeployWarningsListComponent } from '../deploy-warnings-list/deploy-warnings-list.component';

/**
 * The right pane for a channel that has one body and no messages to pick from: whether what
 * the channel would send can be built at all, and nothing else.
 *
 * Deliberately silent when the content is fine. This pane used to badge a green "OK" there,
 * which on a channel whose deploy had just failed was read — correctly — as a claim about the
 * deploy. What the deploy did is reported by `app-deploy-status-detail` above.
 */
@Component({
  selector: 'app-deploy-view-summary',
  imports: [TranslatePipe, StatusPillComponent, DeployWarningsListComponent],
  template: `
    <div class="flex flex-col gap-3">
      @if (!content().isValid) {
        <div class="flex flex-wrap items-center gap-2">
          <app-status-pill [variant]="'danger'" [dot]="true">
            {{ 'features.plan.deploy.table.invalid' | translate }}
          </app-status-pill>
        </div>
      }

      <app-deploy-warnings-list [messages]="content().warnings" />
    </div>
  `,
  styles: ``
})
export class DeployViewSummaryComponent {
  readonly content = input.required<DeployViewResponse['content']>();
}
